import { useEffect, useRef, useState, type JSX } from 'react';
import './components.css';

/** A text box that replaces a label while renaming: Enter commits, Escape cancels, blur commits. */
export function InlineEdit(props: { initial: string; label: string; onSubmit(value: string): void; onCancel(): void }): JSX.Element {
  const { initial, label, onSubmit, onCancel } = props;
  const [value, setValue] = useState(initial);
  const input = useRef<HTMLInputElement>(null);
  const done = useRef(false);

  useEffect(() => {
    input.current?.focus();
    input.current?.select();
  }, []);

  const finish = (commit: boolean): void => {
    if (done.current) return;
    done.current = true;
    const trimmed = value.trim();
    if (commit && trimmed && trimmed !== initial) onSubmit(trimmed);
    else onCancel();
  };

  return (
    <input
      ref={input}
      className="ui-input ui-inline-edit"
      aria-label={label}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={() => finish(true)}
      onClick={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => {
        e.stopPropagation();
        if (e.key === 'Enter') finish(true);
        else if (e.key === 'Escape') finish(false);
      }}
    />
  );
}
